import saleGoodsIndex from '@/pages/saleGoods/index.vue'
import saleGoodsList from '@/pages/saleGoods/saleGoodsList.vue'
import saleGoodsDetail from '@/pages/saleGoods/saleGoodsDetail.vue'

const appRoutes = [{
	path: '/saleGoods',
	redirect: '/saleGoods/saleGoodsList',
	component: saleGoodsIndex,
	children: [{
		path: 'saleGoodsList',
    name: 'saleGoodsList',
		component: saleGoodsList
	},{
		path: 'saleGoodsDetail',
    name: 'saleGoodsDetail',
		component: saleGoodsDetail
	}]
}]
export default appRoutes
